import { render, staticRenderFns } from "./ValuationSubjectWizardCreate.vue?vue&type=template&id=b70056be&"
import script from "./ValuationSubjectWizardCreate.vue?vue&type=script&lang=js&"
export * from "./ValuationSubjectWizardCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports